<main class="p01-intro-page">
  <app-a04-picture-element
    width="1920"
    height="1080"
    webpSrcset="{{ '/assets/images/background/background-light.webp' | assetpipe }}"
    defaultSrc="{{ '/assets/images/background/background-light.jpg' | assetpipe }}"
    [class]="
      !rotationService.isLandscape
        ? 'intro-background-landscape on-portrait'
        : 'intro-background-landscape'
    "
  >
  </app-a04-picture-element>
  <span class="portrait-gradient"></span>

  <app-c01-tv-frame customClass="intro-tv-frame" [hasBlackOverlay]="false">
    <app-c07-tv-intro-screen></app-c07-tv-intro-screen>
  </app-c01-tv-frame>
  <div
    class="content-wrapper"
    [ngClass]="{ 'hisense-content': isValidAndNonGenericBrand && !rotationService.isLandscape }"
  >
    <div class="copy-wrapper">
      <h1 class="heading">
        <picture>
          <source [srcset]="webpLogoAssetUrl" type="image/webp" />
          <source [srcset]="pngLogoAssetUrl" type="image/jpeg" />
          <img
            width="570"
            height="340"
            [attr.alt]="
              !brand ? brand + ' and google tv logos' : 'google logo, chromecast with Google TV'
            "
            [class]="brand ? brand + '-logo' : 'google-logo'"
            [src]="pngLogoAssetUrl"
          />
        </picture>
      </h1>
      <div class="buttons-wrapper" #buttonsContainer>
        <button
          (click)="onPrimaryButtonClick()"
          [ngClass]="{ 'no-compare': !showCompareButton && !showLearnMore && !hasCustomCTA }"
          [attr.aria-label]="copy[jsonKey.WELCOME_PRIMARY_BUTTON_ARIA_LABEL]"
          class="intro-button cta-font-style"
        >
          {{ copy[jsonKey.WELCOME_PRIMARY_BUTTON_COPY] }}
        </button>
        <app-a02-comparison-button
          *ngIf="showCompareButton && !showLearnMore && !hasCustomCTA"
          [isBig]="true"
          [location]="compareButtonLocation"
        ></app-a02-comparison-button>
        <app-a05-custom-cta
          *ngIf="!rotationService.isLandscape && hasCustomCTA"
          customClass="portrait-intro"
        ></app-a05-custom-cta>

        <button
          *ngIf="showLearnMore"
          class="third-party-button cta-font-style"
          (click)="on3PSecondaryButtonClick()"
        >
          {{ copy[jsonKey.WELCOME_SECONDARY_BUTTON_3P_COPY] }}
        </button>
      </div>
    </div>
    <ng-container *ngIf="!brand; else brandPicture">
      <picture>
        <source
          srcset="{{ '/assets/images/p01-intro-page/product.webp' | assetpipe }}"
          type="image/webp"
        />
        <source
          srcset="{{ '/assets/images/p01-intro-page/product.png' | assetpipe }}"
          type="image/jpeg"
        />
        <img
          width="358"
          height="849"
          alt="Chromecast, white Dongle and Control"
          class="chromecast-product"
          src="{{ '/assets/images/p01-intro-page/product.png' | assetpipe }}"
        />
      </picture>
    </ng-container>
    <ng-template #brandPicture>
      <picture *ngIf="isValidAndNonGenericBrand">
        <source [srcset]="webpBrandAssetUrl" type="image/webp" />
        <source [srcset]="pngBrandAssetUrl" type="image/jpeg" />
        <img
          width="358"
          height="849"
          class="chromecast-product"
          alt="Hisense Remote Control with Google Assistant"
          [class]="brand"
          [ngClass]="{ 'hisense-portrait': !rotationService.isLandscape }"
          [src]="pngBrandAssetUrl"
        />
      </picture>
    </ng-template>
  </div>
  <span
    class="black-overlay"
    [ngClass]="{ 'variation-overlay': isValidAndNonGenericBrand && !rotationService.isLandscape }"
  ></span>
  <app-a05-custom-cta *ngIf="rotationService.isLandscape"></app-a05-custom-cta>
</main>
